var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19612 11.9249C9.73177 11.9249 10.2331 11.7871 10.7001 11.5115C11.167 11.236 11.5379 10.8674 11.8126 10.4058C12.0873 9.94415 12.2246 9.44466 12.2246 8.90727C12.2246 8.36988 12.0873 7.86695 11.8126 7.39845C11.5379 6.92996 11.167 6.55793 10.7001 6.28234C10.2331 6.00676 9.73177 5.86897 9.19612 5.86897C8.66047 5.86897 8.16259 6.00676 7.70248 6.28234C7.24236 6.55793 6.87497 6.92996 6.60027 7.39845C6.32558 7.86695 6.18823 8.36988 6.18823 8.90727C6.18823 9.44466 6.32558 9.94415 6.60027 10.4058C6.87497 10.8674 7.24236 11.236 7.70248 11.5115C8.16259 11.7871 8.66047 11.9249 9.19612 11.9249ZM15.6036 9.75471L17.396 11.1602C17.4784 11.2291 17.5265 11.3187 17.5402 11.4289C17.5539 11.5391 17.5333 11.6425 17.4784 11.7389L15.7478 14.7152C15.6929 14.8117 15.6208 14.8737 15.5315 14.9012C15.4422 14.9288 15.3427 14.9219 15.2328 14.8806L13.1108 14.0332C12.5614 14.4328 12.0739 14.7152 11.6481 14.8806L11.3391 17.1335C11.3116 17.2437 11.2601 17.3333 11.1845 17.4022C11.109 17.4711 11.0232 17.5055 10.927 17.5055H7.46592C7.36978 17.5055 7.28394 17.4711 7.2084 17.4022C7.13286 17.3333 7.08822 17.2437 7.07449 17.1335L6.74486 14.8806C6.16801 14.6463 5.6873 14.3639 5.30274 14.0332L3.16015 14.8806C2.9404 14.977 2.76872 14.9219 2.64511 14.7152L0.914559 11.7389C0.85962 11.6425 0.839019 11.5391 0.852753 11.4289C0.866488 11.3187 0.914558 11.2291 0.996966 11.1602L2.80992 9.75471C2.78245 9.56181 2.76872 9.27934 2.76872 8.9073C2.76872 8.53526 2.78245 8.25278 2.80992 8.05988L0.996966 6.6544C0.914558 6.5855 0.866488 6.49594 0.852753 6.3857C0.839019 6.27547 0.85962 6.17213 0.914559 6.07567L2.64511 3.09937C2.76872 2.89268 2.9404 2.83756 3.16015 2.93402L5.30274 3.78144C5.79718 3.4094 6.27788 3.12693 6.74486 2.93402L7.07449 0.68112C7.08822 0.570886 7.13286 0.481322 7.2084 0.412426C7.28394 0.34353 7.36978 0.309082 7.46592 0.309082H10.927C11.0232 0.309082 11.109 0.34353 11.1845 0.412426C11.2601 0.481322 11.3116 0.570886 11.3391 0.68112L11.6481 2.93402C12.1837 3.14071 12.6713 3.42318 13.1108 3.78144L15.2328 2.93402C15.3427 2.89268 15.4422 2.88579 15.5315 2.91335C15.6208 2.94091 15.6929 3.00291 15.7478 3.09937L17.4784 6.07567C17.5333 6.17213 17.5539 6.27547 17.5402 6.3857C17.5265 6.49594 17.4784 6.5855 17.396 6.6544L15.6036 8.05988C15.6311 8.25278 15.6448 8.53526 15.6448 8.9073C15.6448 9.27934 15.6311 9.56181 15.6036 9.75471Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.848633,
    y: 0.309082,
    width: 16.6957,
    height: 17.1964,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsButton);
export default __webpack_public_path__ + "static/media/settings_button.d5bd6fbd9447c958511a766a4915629a.svg";
export { ForwardRef as ReactComponent };